import React from 'react';
import './LocationMap.css';

const LocationMap = () => (
  <div className="location-map">
    <h2 className="map-title">Where you'll be</h2>
    <p className="map-address">123 Baby Lane, Babyville, Babyland, 12345</p>
    
    <div className="map-container">
      <iframe
        title="Location on Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509374!2d144.9537363153169!3d-37.8162797797517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d43f1f1f1f1%3A0x5045675218ce6e0!2sCozy%20Baby%20Cafe!5e0!3m2!1sen!2sus!4v1610000000000!5m2!1sen!2sus"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
      />
    </div>

    <div className="map-info">
      <div className="map-info__item">
        <span className="map-info__icon">🚗</span>
        <div className="map-info__content">
          <span className="map-info__label">By car</span>
          <span className="map-info__text">Free parking available. Family spots near entrance.</span>
        </div>
      </div>
      <div className="map-info__item">
        <span className="map-info__icon">🚇</span>
        <div className="map-info__content">
          <span className="map-info__label">Public transit</span>
          <span className="map-info__text">Bus stop 2 min walk. Metro station 5 min walk.</span>
        </div>
      </div>
      <div className="map-info__item">
        <span className="map-info__icon">♿</span>
        <div className="map-info__content">
          <span className="map-info__label">Accessibility</span>
          <span className="map-info__text">Wheelchair accessible. Elevator available.</span>
        </div>
      </div>
    </div>

    <a 
      href="https://maps.google.com/?q=123+Baby+Lane,+Babyville" 
      target="_blank" 
      rel="noopener noreferrer"
      className="map-directions-btn"
    >
      <span>📍</span> Get directions
    </a>
  </div>
);

export default LocationMap;
